export enum InvitationStatus {
  Accepted = "Accepted",
  Rejected = "Rejected",
  Canceled = "Canceled",
  Open = "Open",
  /**
   * Past its expiry date. The API's InvitationStatusValue has always had it, and the pending
   * invitations list reports it for an invitation whose expiry has passed (#5444).
   */
  Expired = "Expired",
}
